const breakpointMd = window.matchMedia('(min-width:1023px)');
const buttons = document.querySelectorAll('.btn');

const getCoords = (evt) => {
  const button = evt.target;
  if (button.closest('.btn')) {
    const x = evt.offsetX / button.offsetWidth;
    const y = (evt.offsetY + (button.offsetWidth - button.offsetHeight) / 2) / button.offsetWidth;
    button.style.setProperty('--x', 100 * (x - 0.5) + '%');
    button.style.setProperty('--y', 100 * (y - 0.5) + '%');
  }
};

const initButtonHover = () => {
  if (breakpointMd.matches) {
    buttons.forEach((item) => {
      item.addEventListener('mouseenter', getCoords);
      item.addEventListener('mouseleave', getCoords);
    });
  }
};

export {initButtonHover};
